import style from "./LiveStock_Filter.module.css";
function LiveStock_Filter(props: any) {
  return <div className={style["livestock-filter-wrapper"]}>
    
  </div>;
}

export default LiveStock_Filter;
